// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { TransitionGroup } from 'react-transition-group'
import LoadingBar from 'react-redux-loading-bar'
import { Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import createHistoryHashObserver from 'utilities/createHistoryHashObserver'
import HeaderPrimary from 'components/header-primary/header-primary'
import HeaderMobilePrimary from 'components/header-primary/header-mobile-primary'
import PageHeader from 'components/page-header/page-header'
import Sponsors from 'components/sponsors/sponsors'
import Subscribe from 'components/subscribe/subscribe'
import Footer from 'components/footer/footer'
import Page from 'views/main/page/Page'
import Share from 'components/share/share'

// Redux:
import { currentPage } from 'selectors/page'

const siteImage = safeSiteData.site_featured_image_url
const siteImageSrcset = safeSiteData.site_featured_image_srcset

class SiteLayout extends React.Component {
	componentDidMount() {
		const { history } = this.props

		const historyHashObserver = createHistoryHashObserver( history )
	}

	render() {
		let { page, hasSidebar } = this.props
		let mainClass = 'main-wrap'

		if ( page.content_full_width ) {
			hasSidebar = false
		}

		if ( 'apply' == page.template ) {
			mainClass += ' page-apply'
		}

		if ( 'adopted' == page.template ) {
			mainClass += ' page-adopted'
		}

		return (
			<div>
				<Switch>
					<Route path="/" exact component={ HeaderMobilePrimary } />

					<Route path="/:page" exact component={ HeaderMobilePrimary } />
					<Route path="/:page/:subpage" exact component={ HeaderMobilePrimary } />
					<Route path="/:page/animal/:animal" exact component={ HeaderMobilePrimary } />
					<Route path="/:page/:subpage/animal/:animal" exact component={ HeaderMobilePrimary } />
					<Route component={ HeaderMobilePrimary } />
				</Switch>

				<div className={ mainClass }>
					<LoadingBar className="header-loading-bar" updateTime={ 100 } maxProgress={ 90 } progressIncrease={ 10 } />

					<HeaderPrimary url={ this.props.match.url } />

					<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
						<Switch>
							<Route path="/" exact component={ PageHeader } />

							<Route path="/:page" exact component={ PageHeader } />
							<Route path="/:page/:subpage" exact component={ PageHeader } />
							<Route component={ PageHeader } />
						</Switch>
					</TransitionGroup>

					<section className="main">
						<div className="main-inner">
							{ hasSidebar &&
								<div className="secondary-wrap">
									<div className="secondary-content">
										<div className="-share">
											<span className="-text">Share on:</span>

											<Share type="facebook">
												<i className="icon-facebook-square" aria-hidden="true"></i>
											</Share>

											<Share type="twitter">
												<i className="icon-twitter-square" aria-hidden="true"></i>
											</Share>
										</div>

										{ page && page.side_page && page.side_page.image_url &&
											<Link className="-page-link" to={ page.side_page.url }>
												<div className="-image">
													<img src={ page.side_page.image_url } alt={ page.side_page.title } />
												</div>

												<h4 dangerouslySetInnerHTML={ { __html: page.side_page.title } }></h4>

												<div className="-text" dangerouslySetInnerHTML={ { __html: page.side_page.excerpt } }></div>
											</Link>
										}

										{ page && page.side_menu.content &&
											<div className="-custom">
												{ page.side_menu.heading_url &&
													<h3><a href={ page.side_menu.heading_url } dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></a></h3>
												||
													<h3 dangerouslySetInnerHTML={ { __html: page.side_menu.heading } }></h3>
												}

												<div dangerouslySetInnerHTML={ { __html: page.side_menu.content } }></div>
											</div>
										}
									</div>
								</div>
							}

							<div className="primary-wrap">
								<div className="primary-content">
									<TransitionGroup transitionName="page-transition" transitionEnterTimeout={ 500 } transitionLeaveTimeout={ 500 }>
										<Switch>
											<Route path="/" exact component={ Page } />

											<Route path="/:page" exact component={ Page } />
											<Route path="/:page/page/:archivePageNumber" exact component={ Page } />
											<Route path="/:page/:subpage" exact component={ Page } />
											<Route path="/:page/animal/:animal" exact component={ Page } />
											<Route path="/:page/:subpage/animal/:animal" exact component={ Page } />
											<Route component={ Page } />
										</Switch>
									</TransitionGroup>
								</div>
							</div>
						</div>
					</section>
				</div>

				<Subscribe />

				<Footer />
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: currentPage( state ),
		hasSidebar: state.site.hasSidebar
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default withRouter(
	connect( mapStateToProps, mapDispatchToProps )( SiteLayout )
)



// WEBPACK FOOTER //
// ./views/layouts/main/main-layout.jsx